import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { Link } from "react-router-dom";

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-[#fafafa] flex flex-col">
      <SEO
        title="Datenschutzerklärung"
        description="Datenschutzerklärung von Marmoris Studio – Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO."
        path="/datenschutz"
      />
      <Header />
      <main
        className="flex-1 section-spacing"
        style={{ paddingTop: "calc(var(--header-height, 6rem) + 3rem)" }}
      >
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <Link
              to="/"
              className="inline-block text-[#4a9da8] hover:text-[#2c4a52] text-sm font-medium mb-8 transition-colors"
            >
              ← Zurück zur Startseite
            </Link>
            <h1 className="text-4xl md:text-5xl font-bold text-[#0f1419] mb-2">
              Datenschutzerklärung
            </h1>
            <p className="text-lg text-[#3a3a3a]/80 mb-2">
              Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO
            </p>
            <p className="text-[#3a3a3a]/70 mb-10">Stand: März 2026</p>

            <div className="prose prose-lg text-[#3a3a3a] space-y-8 prose-headings:break-words prose-p:break-words max-w-none">
              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  1. Verantwortlicher
                </h2>
                <p className="leading-relaxed mb-2">
                  Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO):
                </p>
                <address className="not-italic leading-relaxed">
                  Jakob Dietmar Riegler<br />
                  Marmoris Studio<br />
                  Weinleiten 7<br />
                  9400 Wolfsberg<br />
                  Österreich
                </address>
                <p className="leading-relaxed mt-4">
                  Telefon: <a href="tel:+436649992990" className="text-[#4a9da8] hover:underline">+43 664 9992990</a><br />
                  E-Mail: <a href="mailto:office@marmoris.at" className="text-[#4a9da8] hover:underline">office@marmoris.at</a><br />
                  Website: <a href="https://marmoris.at" target="_blank" rel="noopener noreferrer" className="text-[#4a9da8] hover:underline">https://marmoris.at</a>
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  2. Allgemeine Informationen zur Datenverarbeitung
                </h2>
                <p className="leading-relaxed mb-4">
                  Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten personenbezogene Daten ausschließlich im Einklang mit den geltenden gesetzlichen Bestimmungen der Datenschutz-Grundverordnung (DSGVO) sowie des Telekommunikationsgesetzes (TKG 2021).
                </p>
                <p className="leading-relaxed">
                  Beim Besuch dieser Website werden personenbezogene Daten nur im technisch notwendigen Umfang verarbeitet. Eine weitergehende Verarbeitung erfolgt nur, wenn Sie uns aktiv kontaktieren.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  3. Hosting der Website
                </h2>
                <p className="leading-relaxed mb-4">
                  Diese Website wird über den Hostinganbieter Netlify bereitgestellt.
                </p>
                <p className="leading-relaxed mb-2">
                  <strong>Anbieter:</strong><br />
                  Netlify Inc.<br />
                  2325 3rd Street, Suite 296<br />
                  San Francisco, CA 94107<br />
                  USA
                </p>
                <p className="leading-relaxed mb-4 mt-4">
                  Beim Aufruf der Website werden automatisch technische Informationen (Server-Logfiles) verarbeitet, insbesondere:
                </p>
                <ul className="list-disc pl-6 space-y-1 leading-relaxed mb-4">
                  <li>IP-Adresse</li>
                  <li>Datum und Uhrzeit des Zugriffs</li>
                  <li>Browsertyp und Browserversion</li>
                  <li>Betriebssystem</li>
                  <li>Referrer-URL</li>
                  <li>HTTP-Statuscode</li>
                </ul>
                <p className="leading-relaxed mb-4">
                  Diese Daten werden zur technischen Bereitstellung der Website sowie zur Sicherstellung der Systemsicherheit verarbeitet.
                </p>
                <p className="leading-relaxed mb-2">
                  <strong>Rechtsgrundlage:</strong><br />
                  Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an stabiler und sicherer Bereitstellung der Website)
                </p>
                <p className="leading-relaxed">
                  Weitere Informationen:{" "}
                  <a href="https://www.netlify.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-[#4a9da8] hover:underline">https://www.netlify.com/privacy/</a>
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  4. Kontaktformular
                </h2>
                <p className="leading-relaxed mb-4">
                  Wenn Sie über das Kontaktformular Kontakt mit uns aufnehmen, werden die von Ihnen eingegebenen Daten zur Bearbeitung Ihrer Anfrage verarbeitet.
                </p>
                <p className="leading-relaxed mb-2"><strong>Verarbeitete Daten:</strong></p>
                <ul className="list-disc pl-6 space-y-1 leading-relaxed mb-4">
                  <li>Name</li>
                  <li>E-Mail-Adresse</li>
                  <li>Telefonnummer</li>
                  <li>Nachricht / Anliegen</li>
                </ul>
                <p className="leading-relaxed mb-4">
                  Die Formularfunktion wird über Netlify Forms bereitgestellt. Die eingegebenen Daten werden über die Server von Netlify verarbeitet und anschließend per E-Mail an uns übermittelt.
                </p>
                <p className="leading-relaxed mb-2"><strong>Rechtsgrundlagen:</strong></p>
                <ul className="list-disc pl-6 space-y-1 leading-relaxed">
                  <li>Art. 6 Abs. 1 lit. b DSGVO (Vertrag oder Vertragsanbahnung)</li>
                  <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Kommunikation)</li>
                  <li>Art. 6 Abs. 1 lit. a DSGVO (freiwillige Kontaktaufnahme)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  5. Auftragsverarbeitung
                </h2>
                <p className="leading-relaxed mb-4">
                  Netlify verarbeitet personenbezogene Daten als Auftragsverarbeiter gemäß Art. 28 DSGVO.
                </p>
                <p className="leading-relaxed mb-4">
                  Mit Netlify besteht ein Vertrag zur Auftragsverarbeitung (Data Processing Agreement).
                </p>
                <p className="leading-relaxed">
                  Weitere Informationen:{" "}
                  <a href="https://www.netlify.com/gdpr/" target="_blank" rel="noopener noreferrer" className="text-[#4a9da8] hover:underline">https://www.netlify.com/gdpr/</a>
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  6. Datenübermittlung in Drittländer
                </h2>
                <p className="leading-relaxed mb-4">
                  Da Netlify ein US-amerikanisches Unternehmen ist, kann eine Übermittlung personenbezogener Daten in die USA erfolgen.
                </p>
                <p className="leading-relaxed mb-4">
                  Die Datenübermittlung erfolgt auf Grundlage der EU-Standardvertragsklauseln (Standard Contractual Clauses – SCC) gemäß Art. 46 DSGVO.
                </p>
                <p className="leading-relaxed">
                  Es kann nicht vollständig ausgeschlossen werden, dass US-Behörden unter bestimmten gesetzlichen Voraussetzungen Zugriff auf übermittelte Daten erhalten.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  7. Speicherdauer
                </h2>
                <p className="leading-relaxed mb-4">
                  Personenbezogene Daten werden nur so lange gespeichert, wie dies zur Bearbeitung Ihrer Anfrage erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
                </p>
                <p className="leading-relaxed">
                  Daten aus Kontaktanfragen werden gelöscht, sobald der Zweck der Verarbeitung entfallen ist und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  8. Verwendung von Schriftarten
                </h2>
                <p className="leading-relaxed mb-4">
                  Diese Website verwendet lokal eingebundene Schriftarten (Inter).
                </p>
                <p className="leading-relaxed">
                  Die Schriftdateien werden direkt vom eigenen Webserver geladen. Dabei findet keine Verbindung zu externen Schriftanbietern wie Google Fonts statt.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  9. Cookies und Tracking
                </h2>
                <p className="leading-relaxed mb-4">
                  Diese Website verwendet keine Cookies, keine Tracking-Tools und keine Analyse-Dienste.
                </p>
                <p className="leading-relaxed">
                  Es werden keine personenbezogenen Daten zu Marketing- oder Analysezwecken erfasst.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  10. Datensicherheit
                </h2>
                <p className="leading-relaxed mb-4">
                  Diese Website verwendet eine SSL- bzw. TLS-Verschlüsselung (HTTPS), um übermittelte Daten bestmöglich zu schützen.
                </p>
                <p className="leading-relaxed">
                  Darüber hinaus werden angemessene technische und organisatorische Maßnahmen getroffen, um personenbezogene Daten vor Verlust, Missbrauch oder unbefugtem Zugriff zu schützen.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  11. Ihre Rechte
                </h2>
                <p className="leading-relaxed mb-4">
                  Sie haben jederzeit folgende Rechte gemäß DSGVO:
                </p>
                <ul className="list-disc pl-6 space-y-1 leading-relaxed mb-4">
                  <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
                  <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
                  <li>Recht auf Löschung (Art. 17 DSGVO)</li>
                  <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                  <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
                  <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
                  <li>Recht auf Widerruf einer Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
                </ul>
                <p className="leading-relaxed">
                  Zur Ausübung Ihrer Rechte wenden Sie sich bitte an die oben genannte E-Mail-Adresse.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  12. Beschwerderecht
                </h2>
                <p className="leading-relaxed mb-4">
                  Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen Datenschutzrecht verstößt, haben Sie das Recht, Beschwerde bei der zuständigen Aufsichtsbehörde einzulegen.
                </p>
                <p className="leading-relaxed mb-2">
                  <strong>Zuständige Behörde in Österreich:</strong>
                </p>
                <p className="leading-relaxed mb-2">
                  Österreichische Datenschutzbehörde<br />
                  Barichgasse 40–42<br />
                  1030 Wien<br />
                  Österreich
                </p>
                <p className="leading-relaxed">
                  Website:{" "}
                  <a href="https://www.dsb.gv.at" target="_blank" rel="noopener noreferrer" className="text-[#4a9da8] hover:underline">https://www.dsb.gv.at</a>
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  13. Automatisierte Entscheidungsfindung
                </h2>
                <p className="leading-relaxed">
                  Eine automatisierte Entscheidungsfindung einschließlich Profiling gemäß Art. 22 DSGVO findet nicht statt.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  14. Änderungen dieser Datenschutzerklärung
                </h2>
                <p className="leading-relaxed mb-4">
                  Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich rechtliche Anforderungen ändern oder neue Funktionen auf unserer Website implementiert werden.
                </p>
                <p className="leading-relaxed">
                  Die jeweils aktuelle Version ist jederzeit auf dieser Website abrufbar.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Datenschutz;
